export default "<mat-icon\n  [matTooltip]=\"text\"\n  [matTooltipPosition]=\"position\">info\n</mat-icon>\n"